import { confirmationFormulaireMock } from '@mock/schema/components';
import { SlugPage } from '@pages/slug-page/models';
import { pageBase } from '@mock/schema/slugs/config';

const blocks = [confirmationFormulaireMock];
const title = 'Confirmation Envoi Formulaire Contact';

export const confirmationEnvoiFormulaireContactMock: SlugPage = {
  ...pageBase({
    title,
    type: 'undefined',
    language: 'fr-FR',
    headerId: 'header-fr',
    footerId: 'footer-fr',
    isBreadcrumbOverlay: false,
  }),
  blocks,
};
